import md5 from 'md5';
import { cleanHostName } from '../../util/helpers';
import AjaxUtils from '../../util/ajax_utils';
import { CodemirrorArea } from '../swagger/codemirror_area';

export const ApckGoScriptAuthProfile = {
    components: {
        'codemirror-area': CodemirrorArea,
    },
    props: {
        profile: {
            type: Object,
        },
        message: {
            type: String,
        },
        scopeSelectedValues: {
            type: Array,
        },
        showCode: {
            // This prop helps to rerender CodeMirror
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            profileData: [],
            observedList: [],
            observedListScope: [],
            scopeValidationResults: [],
        };
    },
    watch: {
        message(newValue) {
            this.profileData = this.messageToObject(newValue);
        },
    },
    methods: {
        messageToObject(text) {
            // TODO: Refactor the auth profile to use JSON data instead of parsing messages.
            const cmp = this;
            if (!text) return [];
            if (!text.includes('Main application')) return [];
            const lines = text.split('\n');
            const data = [];
            cmp.observedList = [];
            let currentSection = {
                section: 'General',
                options: [],
                type: 'table',
            };
            data.push(currentSection);

            lines.forEach((line) => {
                let currentLine = line;
                if (
                    currentLine.startsWith('--') ||
                    currentLine.startsWith('##') ||
                    currentLine.toLowerCase().startsWith('detected message rules')
                ) {
                    // new section
                    const section = currentLine.replace(/^[-\s]+|[-\s]+$/g, '').replace(/^[#\s]+|[#\s]+$/g, '');
                    let type = 'table';
                    if (currentLine.startsWith('--')) type = 'table';
                    if (currentLine.startsWith('##')) type = 'text';
                    if (section.toLowerCase().startsWith('detected message rules')) type = 'text';
                    currentSection = {
                        section,
                        options: [],
                        type,
                        text: '',
                    };
                    data.push(currentSection);
                } else if (currentSection.section === 'Observed applications') {
                    // Observed section
                    if (currentLine) {
                        const observedList = currentLine.split(',').map((url) => url.trim());
                        cmp.observedList.push(...observedList);
                    }
                } else {
                    // Process section content
                    if (currentSection.type === 'table') {
                        // Handle edge cases
                        // Cleanup links
                        if (currentLine.trim().startsWith('- http')) {
                            currentLine = currentLine.replace(/^\s*-\s+/, ' ');
                        }

                        // Ignore splitting
                        if (currentSection.section.startsWith('Message Signing Requirement')) {
                            if (currentLine.trim().startsWith('- ')) {
                                currentSection.options.push({ key: currentLine, value: '' });
                                return;
                            }
                        }
                        // Convert to two columns
                        if (currentLine.includes(': ')) {
                            // table section
                            let [key, value] = currentLine.split(/: (.+)?/, 2);
                            key = key.trimEnd();
                            // fix 'Observed Requests        :'
                            key = key.replace(/\s+:$/, ':');
                            if (value) {
                                if (value.trim() === ':') value = '';
                                currentSection.options.push({ key, value });
                            } else {
                                currentSection.options.push({ key, value: '' });
                            }
                        } else {
                            // fix 'Observed Requests        :'
                            const key = currentLine.replace(/\s+:$/, ':');
                            // Fill only the key value in the output in the left column
                            currentSection.options.push({ key, value: '' });
                        }
                    } else {
                        // Text section
                        currentSection.text += '\r\n' + currentLine;
                    }
                }
            });

            const scopeList = cmp.observedList
                .map((element) => 'http://' + cleanHostName(element))
                .map((element) => {
                    // Manually add the `http` to the target for checking. Only the web targets are in this list but its
                    // stripped as auth only really needs the domain. It must be added back for a successful scope check
                    return { name: element, id: md5(element) };
                });

            // prepare observed applications scope
            cmp.scopeValidationResults = [];
            AjaxUtils.ajax_post({
                url: '/validate/scope',
                data: JSON.stringify(scopeList),
                success: function (data) {
                    // get organisation scope
                    cmp.scopeValidationResults = data;
                    cmp.scopeValidationResults.forEach((obj) => {
                        // update name
                        let updateItem = scopeList.find((item) => item.id === obj.id);
                        if (updateItem) {
                            obj.name = updateItem.name;
                        }
                        if (obj.reason === 'not in scope') obj.reason = 'out of scope';

                        // check analysis scope
                        if (cmp.scopeSelectedValues.includes(cleanHostName(obj.name))) obj.analysis = 'in scope';
                        else obj.analysis = 'out of scope';
                    });
                },
            });

            return data;
        },
        getStyle(value) {
            const styleMap = {
                'auth detected': 'bg-positive',
                'not determined': 'bg-warning',
                'out of scope': 'bg-negative',
                'not in scope': 'bg-negative',
                'in scope': 'bg-positive',
                'cannot be resolved': 'bg-warning',
            };
            const lowerValue = value.toLowerCase();

            for (const [key, style] of Object.entries(styleMap)) {
                if (lowerValue.includes(key)) {
                    return style;
                }
            }
            return '';
        },
        isLink(value) {
            if (!value) return false;
            // Simple regex to check if value starts with http or https, adjust for more specificity if needed
            const pattern = /^(http|https):\/\//;
            return pattern.test(value.trim());
        },
        getTooltip(tooltipName) {
            if (typeof tooltipName !== 'string') return '';
            if (!tooltipName) return '';
            tooltipName = tooltipName.trim();
            // TODO: move out
            /* eslint-disable */
            // prettier-ignore
            const tooltips = {
                "Main application" : "The application for which authentication must be applied to requests.",
                "Method" : "The means by which the authentication flow was described.",
                "Analysis outcome" : "",
                "Auth detected" : "AppCheck was able to successfully execute the authentication flow, analyse the requests and responses in order to successfully apply the authentication to requests outside of the browser context, and identify an indicator target which can be used outside the browser context to confirm with the authentication state information is still valid.",
                "Auth Mechanism NOT DETERMINED" : "AppCheck was able to successfully execute the authentication flow; however, there was an issue with the analysis, which means the scanner may not be able to apply this authentication to requests and/or determine if the authentication has become invalid.",
                "Auth Mechanism NOT DETERMINED: failed to determine auth indicator" : "The analysis did not identify a request within the scope of the application which can be used to determine if the authentication state information is still valid. ",
                "Auth Mechanism NOT DETERMINED: failed to utilise known tokens" : "The \"known tokens\" configured by the user for the analysis were not used in the requests observed by the analysis.",
                "Auth Mechanism NOT DETERMINED: failed to determine token rules" : "The analysis did not identify where to extract authentication state information \"tokens\" from and/or how to apply them to requests.",
                "Auth Mechanism NOT DETERMINED: failed to apply extracted session state" : "The analysis was not able to make an authenticated request using the authentication state information acquired from the authentication flow.",
                "Auth Mechanism NOT DETERMINED: failed to confirm new session authenticated" : "The analysis was not able to use its findings to create a new authenticated session with the application.",
                "Auth Mechanism NOT DETERMINED: unknown" : "An unexpected failure in the auth analysis process. Please report this to the AppCheck support team.",
                "User concurrency constraints" : "Limitations the application places on a user that attempts to create multiple authenticated sessions concurrently.",
                "exclusive" : "This authentication does not allow concurrent user sessions: the latest session invalidates an earlier session.",
                "exclusive_lockout" : "This authentication does not allow concurrent user sessions: the earlier session prevents a new session.",
                "Can sync browser to session" : "AppCheck is able to apply the authentication state information to a new browser session, placing the browser into an authenticated session with the application for use by the scanner.",
                "Post-login URL" : "The URL of the application in the browser after the authentication flow has successfully executed.",
                "Requires browser storage" : "The application uses information in the browser's DOM storage to maintain authentication.",
                "Verified users" : "The username used for during analysis.",
                "<embedded_user>" : "A username was not provided in a {username} variable, this usually means the username is embedded in the authentication script or the application does not use a traditional username.",
                "Max re-auth attempts" : "The maximum number of attempts allowed during analysis when the authentication flow failed.",
                "no logout flow specified" : "Logout analysis skipped. Please define an auth.logout function, since it improves auth analysis detail and accuracy.",
                "correctly invalidates session" : "The logout function invalidates the authenticated state information, i.e. the authentication token cannot continue to be used with the application.",
                "fails to invalidate session" : "The logout function does not invalidate the authentication state information, i.e. the authentication token can continue to be used with the application.",
                // TODO:
                // "<none>" : "Logout analysis not reached due to login analysis failure.",
                "Logout requests" : "HTTP requests which the analysis determined terminated the authenticated session.",
                "Used custom message rules" : "Custom message rules configured by the user were used during the analysis.",
                "Auth Indicator 0": "The analysis identified the following request(s) to determine if the authentication state information is valid, based on the requests observed when executing the provided authentication functions. Note that an auth indicator for the main application must be identified for AppCheck to correctly handle authentication during a scan.",
                "Auth checking request": "The HTTP request which will be used to confirm the authenticated state information is still valid with the application.",
                "Detection technique": "The difference in response from the server when the authenticated state information is valid vs invalid.",
                "StrongResponseChange": "The application responds with a different status code, a redirect, fails to respond, or some other key difference in response type which can be used identify the change in authentication state.",
                "SignificantResponseChange": "The application responds has significant difference in content length or other \"fuzzy\" difference in its response which can be used to identify the change in authentication state.",
                "ConsistentResponseLength": "The application response to the auth indicator has a consistent content length which can be used to identify the change in authentication state.",
                "KeywordChanges": "The application's response to a request with valid or invalid authentication state has key words present which can be used to identify the change in authentication state.",
                "Required auth tokens": "The following authentication state information in the request was identified by the analysis. These tokens will be updated on requests during the scan.",
                "- Cookies": "Tokens in HTTP Cookies that impact the authenticated state.",
                "- Headers": "Tokens in HTTP Headers that impact the authenticated state.",
                "- Inline": "Tokens within the HTTP request (URL path or query string parameters, form/JSON/XML body data) that impact the authenticated state.",
                "- Can auth with either": "The application uses both cookies and headers but will accept either, not requiring both to be present.",
                "Observed applications": "The analysis observed requests to the following applications during analysis. This is often due to the use of third party JavaScript libraries included from Content Delivery Networks or similar, however API's used by the front end application may also be present. Any API's should be reviewed for inclusion within the scan scope to ensure that all expected features of the application undergo security testing."
                }
            /* eslint-enable */
            if (tooltipName.includes('Auth Mechanism NOT DETERMINED'))
                return tooltips['Auth Mechanism NOT DETERMINED'] + ' ' + tooltips[tooltipName];
            return tooltips[tooltipName];
        },
    },
    template: `
        <div>
            <div v-for="table in profileData" :key="table.sectionName">
                <div class="goscript-bottom__title">{{ table.section }} &nbsp; <VueCustomTooltip v-if="getTooltip(table.section)" position="is-right" :multiline="true" :label="getTooltip(table.section)"><i class="fa fa-info-circle"></i></VueCustomTooltip></div>
                <div v-if="table.type === 'text' && table.text.trim()">
                    <codemirror-area v-if="showCode" :value="table.text" :read-only="true" />
                </div>
                <div v-if="table.type === 'table'" class="property-table">
                    <div class="property-table__row">
                        <div class="property-table__cell"></div>
                        <div class="property-table__cell"></div>
                    </div>
                    <div
                        v-for="item, index in table.options"
                        :key="index"
                        class="property-table__row"
                        :class="{'property-table__row--single': !item.value}"
                    >
                        <div class="property-table__cell">
                            <a v-if="isLink(item.key)" :href="item.key" target="_blank">{{ item.key }}</a>
                            <template v-else><span class="property-table__cell__text property-table__cell__text--pre">{{ item.key }}</span></template>
                             &nbsp; <VueCustomTooltip v-if="getTooltip(item.key)" position="is-right" :multiline="true" :label="getTooltip(item.key)"><i class="fa fa-info-circle"></i></VueCustomTooltip></div>
                        <div
                            v-if="item.value"
                            :class="['property-table__cell', getStyle(item.value)]"
                        >
                            <a v-if="isLink(item.value)" :href="item.value" target="_blank">{{ item.value }}</a>
                            <template v-else><span class="property-table__cell__text property-table__cell__text--pre">{{ item.value }}</span></template>
                            &nbsp; <VueCustomTooltip v-if="getTooltip(item.value)" position="is-right" :multiline="true" :label="getTooltip(item.value)"><i class="fa fa-info-circle"></i></VueCustomTooltip>
                        </div>
                    </div>
                </div>
                <div v-if="table.section === 'Observed applications'" class="property-table">
                    <div class="property-table__row property-table__row--three">
                        <div class="property-table__cell property-table__cell--capitalize">
                            <span class="property-table__cell__text">Application</span>
                        </div>
                        <div class="property-table__cell property-table__cell--capitalize">
                            <span class="property-table__cell__text">Organisation scope</span>&nbsp;<VueCustomTooltip position="is-right" :multiline="true" label="Indicates if your organisation is allowed to scan the observed application."> <i class="fa fa-info-circle"></i></VueCustomTooltip>
                        </div>
                        <div class="property-table__cell property-table__cell--capitalize">
                            <span class="property-table__cell__text">Scan Scope</span>&nbsp;<VueCustomTooltip position="is-right" :multiline="true" label="Indicates if the observed application is allowed by the analysis configuration."> <i class="fa fa-info-circle"></i></VueCustomTooltip>
                        </div>
                    </div>
                    <div
                        class="property-table__row property-table__row--three"
                        v-for="scope in scopeValidationResults"
                    >
                        <div class="property-table__cell">
                            <a v-if="isLink(scope.name)" :href="scope.name" target="_blank">{{ scope.name }}</a>
                            <template v-else>{{ scope.name }}</template>
                        </div>
                        <div :class="['property-table__cell', 'property-table__cell--capitalize', getStyle(scope.reason)]">{{scope.reason}}</div>
                        <div :class="['property-table__cell', 'property-table__cell--capitalize', getStyle(scope.analysis)]">{{scope.analysis}}</div>
                    </div>
                </div>
            </div>
        </div>
    `,
};
